// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"6bf90c2b","511":"e2f8ee29","598":"bc92fa19","787":"0d90cc2c"}[chunkId] + ".chunk.js";
};